<article
  (click)="handleClick()"
  [ngClass]="{
    'no-padding-for-bookmarks': app.isBookmark,
    'big-container': displayType === DisplayType.BIG,
    'small-container': displayType === DisplayType.SMALL,
  }"
  class="app-icon-container relative"
>
  @if (isUnpublished) {
    <div class="absolute inset-0 z-10 bg-black/60 flex flex-col items-center justify-center gap-0.5">
      <i class="boschicon-bosch-ic-service-time text-white text-sm"></i>
      <span class="text-white text-[7px] leading-none text-center">{{ 'app-manager.status.unpublished' | translate }}</span>
    </div>
  }
  <a class="select-none">
    @defer (on viewport) {
      @if (app.isBookmark) {
        <bookmark-icon
          [ngClass]="{
            'big-image': displayType === DisplayType.BIG,
            'small-image': displayType === DisplayType.SMALL,
          }"
          [bookmark]="app"
        />
      } @else {
        <img
          [ngClass]="{
            'big-image': displayType === DisplayType.BIG,
            'small-image': displayType === DisplayType.SMALL,
          }"
          class="select-none m-auto"
          [src]="app.appIconURL"
          alt=""
          disableContextMenu
          withFallbackImage
        />
      }
    } @placeholder {
      <div
        [ngClass]="{
          'big-image': displayType === DisplayType.BIG,
          'small-image': displayType === DisplayType.SMALL,
        }"
      ></div>
    }
  </a>
</article>
